import React from 'react';
import {inject, observer} from 'mobx-react';


const FlowItem = (props) => {
    const {className, title, isLast, onClick = null} = props;

    return (
        <>
            <div onClick={onClick} className={'flowItem-container'}>
                <p className={`flowItem-p flowItem-${className}`}>{title}</p>
                <div className={`circle flowItem-${className}`} />
                {!isLast && <div className={`verticalLine flowItem-${className === 'active' ? 'inactive' : className}`}/>}
            </div>
        </>
    );
};

export default inject('siaStore')(observer(FlowItem));
